import { alpha } from '@mui/material';

export const MuiPaperConfig = {
    defaultProps: {},
    variants: [
        {
            props: { variant: 'outlined' },
            style: ({ theme }: { theme: any }) => {
                return {
                    borderColor: alpha(theme.palette.text.primary, 0.08),
                };
            },
        },
    ],
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                backgroundColor: theme.palette.background.default,
            };
        },
    },
};
